/**
 * "View guidelines" menu action: analytics + opens NCCN guidelines flow.
 *
 * @module handleViewGuidelines
 */
import { Item } from "../../../../data-model/documentModalWithSideBav";
import {
  AuthOnFile,
  GeneralOrderDetails,
} from "../../../../data-model/medicalPaOrdersModel";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { handleViewNccnGuidelines } from "../../../../pages/medicalPaForm/components/utils/handleViewNccnGuidelines";
import { AppDispatch } from "../../../../redux/store/store";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

/** Parameters for {@link handleViewGuidelines}. */
export interface HandleViewGuidelinesParams {
  dispatch: AppDispatch;
  authOnFile: AuthOnFile;
  generalOrderDetails: GeneralOrderDetails;
  items: Item[];
  orgId: string;
  userId: string;
  userEmail: string;
  payerName: string;
  /** BigQuery screen name attached to the analytics events. */
  screenName: ScreenNamesForBigQuery;
}

/**
 * Handles the "View Guidelines" action.
 * Opens the NCCN guidelines modal and logs the event.
 *
 * @param params - Parameters for the action
 */
export const handleViewGuidelines = ({
  dispatch,
  authOnFile,
  generalOrderDetails,
  items,
  orgId,
  userId,
  userEmail,
  payerName,
  screenName,
}: HandleViewGuidelinesParams): void => {
  apiWorkerManager.enqueueAndProcess({
    patient_id:
      generalOrderDetails?.demographics?.patient_id ??
      generalOrderDetails?.demographics?.patient_mrn ??
      "",
    order_id: generalOrderDetails?.order_id ?? "",
    org_id: orgId ?? "",
    event_name: EventsName.VIEW_GUIDELINES_CLICKED,
    user_id: userId,
    user_email: userEmail,
    additional_data: {
      screen_name: screenName,
      payer_name: payerName,
    },
  });

  handleViewNccnGuidelines(dispatch, items, {
    event_name: EventsName.VIEW_NCCN_GUIDELINES_CLICKED,
    patient_id:
      generalOrderDetails?.demographics?.patient_id ??
      generalOrderDetails?.demographics?.patient_mrn ??
      "",
    order_id: generalOrderDetails?.order_id ?? "",
    org_id: orgId ?? "",
    user_id: userId,
    user_email: userEmail,
    additional_data: {
      screen_name: screenName,
      payer_name: payerName,
    },
  });
};
